<template>
  <div class="app-main-layout">
    <Navbar />

    <div class="main-content-layout">
      <Sidebar />

      <router-view />
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/app/general/Navbar";
import Sidebar from "@/components/app/general/Sidebar";

export default {
  name: "main-layout",
  components: { Navbar, Sidebar },
};
</script>

<style lang="scss">
.app-main-layout {
  background-color: #3b3b3b;
  height: 100vh;

  .main-content-layout-with-sidebar {
    width: 100%;
    height: calc(100vh - 60px);
    display: flex;
    flex-direction: row;
    justify-content: stretch;
  }

  .main-content-layout {
    width: 100%;
    height: calc(100vh - 60px);

    display: flex;
    flex-direction: row;
    justify-content: stretch;
  }
}
</style>
